import {
  Action,
  ActionType,
  IDownloadPDFContractResponse,
} from "models/contract/downloadPDF";
import createReducer from "../../createReducer";

export interface DownloadPDFContractReducerType {
  loading: boolean;
  error?: string;
  downloadPDFContractResponse?: IDownloadPDFContractResponse;
}

const defaultState: DownloadPDFContractReducerType = {
  loading: false,
  error: undefined,
  downloadPDFContractResponse: undefined,
};

export const downloadPDFContractReducer =
  createReducer<DownloadPDFContractReducerType>(defaultState, {
    [ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF](
      state: DownloadPDFContractReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_ERROR](
      state: DownloadPDFContractReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_SUCCESS](
      state: DownloadPDFContractReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadPDFContractResponse: action.payload,
      };
    },

    [ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_RESET](
      state: DownloadPDFContractReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadPDFContractResponse: undefined,
      };
    },
  });
